import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

interface AdminRouteGuardProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

export default function AdminRouteGuard({
  children,
  fallbackPath = '/dashboard'
}: AdminRouteGuardProps) {
  const { user, loading, isAdmin } = useUser();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to={fallbackPath} replace />;
  }
  return <>{children}</>;
} 